"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Image = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconLibrary = require("../../packages/IconLibrary/");
var _index = _interopRequireDefault(require("../Disclaimer/index.styled"));
var _LexusLoadingIcon = _interopRequireDefault(require("../LexusLoadingIcon"));
var _Typography = require("../Typography");
const PlayPause = _styledComponents.default.button`
  background: none;
  border: none;
  position: absolute;
  right: 15px;
  top: 15px;
  width: 50px;
  height: 50px;
  color: #111;
  z-index: 9;
  cursor: pointer;

  opacity: 0.8;
  transition: ease all 250ms;

  &:hover, &:focus {
    opacity: 1;
  }

  svg {
    height: 100% !important;
    width: 100% !important;
  }
`;
const Image = exports.Image = _styledComponents.default.div`
  position: relative;
  width: 100%;
  z-index: 0;
  ${function (_ref) {
  let {
    fullscreen
  } = _ref;
  return fullscreen && `
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  `;
}}
`;
const Play = (0, _styledComponents.default)(_IconLibrary.PlayButton)`
  width: clamp(60px, 5vw, 80px) !important;
  height: clamp(60px, 5vw, 80px) !important;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  opacity: 0.8;
  pointer-events: none;
  object-fit: contain;
  aspect-ratio: 1;
`;
const Styled = {
  NestedContent: _styledComponents.default.div`
    position: absolute;
    inset: 0;
  `,
  Image,
  ImgDom: _styledComponents.default.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;

    ${function (_ref2) {
    let {
      fullscreen
    } = _ref2;
    return fullscreen && `
      height: auto;
      max-height: calc(100% - 20px);
    `;
  }}
  `,
  MediaDisclaimer: (0, _Typography.StyledType)("span", {
    size: "disclaimer",
    family: "nobel-book"
  })`
    z-index: 1;
    padding: 0 8px 5px 8px;
    color: ${function (_ref3) {
    let {
      color
    } = _ref3;
    return color || "#FFF";
  }};
    box-sizing: border-box;
    width: 100%;
    ${function (_ref4) {
    let {
      fullscreen
    } = _ref4;
    return fullscreen && `
      position: static;
      display: block;
      padding: 5px 10px 0 8px;
    `;
  }}
    ${function (_ref5) {
    let {
      $position
    } = _ref5;
    return $position && `
      ${$position === "right" && `
          text-align: right;
        ` || $position === "center" && `
          text-align: center;
        ` || `
          text-align: left;
        `};
    `;
  }}
  }}
  `,
  DisclaimerOuterContainer: _styledComponents.default.div`
    position: absolute;
    width: 100%;
    bottom: 0;

    ${_index.default.Disclaimer}{
      z-index: 2;
    }
`,
  DisclaimerInnerContainer: _styledComponents.default.div`
    position: relative;
    display: flex;
    align-items: center;

    ${function (_ref6) {
    let {
      $position
    } = _ref6;
    return $position && `
      ${$position === "right" && `
          justify-content: right;
        ` || $position === "center" && `
          justify-content: center;
        ` || `
          justify-content: left;
          flex-direction: row-reverse;
        `};
    `;
  }}
`,
  BackgroundVideo: _styledComponents.default.video`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    object-fit: cover;
    opacity: ${function (_ref7) {
    let {
      $show
    } = _ref7;
    return $show ? "1" : "0";
  }};
  `,
  HtmlVideo: _styledComponents.default.video`
    display: block;
    width: 100%;
  `,
  Play,
  LoadingIcon: (0, _styledComponents.default)(_LexusLoadingIcon.default)`
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  `,
  Video: _styledComponents.default.div`
    display: block;
    position: relative;
    cursor: pointer;

    &:hover ${Play} {
      opacity: 1;
    }
  `,
  Poster: _styledComponents.default.div`
    display: block;
    cursor: pointer;
    pointer-events: none;
    display: flex;
    ${function (_ref8) {
    let {
      fullscreen
    } = _ref8;
    return fullscreen && `
      height: 100%;
      width: 100%;
    `;
  }}
    ${function (_ref9) {
    let {
      disableInteractiveVideo
    } = _ref9;
    return disableInteractiveVideo ? `
      position: relative;

    ` : `
      top: 0;
      left: 0;
      position: absolute;
      width: 100%;
      height: 100%;
    `;
  }}
  `,
  PlayPause
};
var _default = exports.default = Styled;